__turbopack_context__.v({
  "badge": "ckRvja_badge",
  "card": "ckRvja_card",
  "metaLine": "ckRvja_metaLine",
  "select": "ckRvja_select",
  "selectEmpty": "ckRvja_selectEmpty",
  "selectWrapper": "ckRvja_selectWrapper",
  "title": "ckRvja_title",
  "titleRow": "ckRvja_titleRow",
});
